export default function () {

  //.nav-main 内の現在のページのリンクに @aria-current を追加　.js-throwgh があるものは除く
  const path = location.pathname
  const mainLink = document.querySelectorAll('.l-nav__list a');
  const pageLink = document.querySelectorAll('.p-pagelink a');
  const catLink = document.querySelectorAll('.p-catlink a');

	if(path.match('/ir/')) {
		document.querySelector('.l-nav__list a[href="/ir/"]').setAttribute('aria-current', 'page');
	}


  [].forEach.call(mainLink, el => {
    if (el.getAttribute('href') == path) {
      if (!el.classList.contains('js-throwgh')) {
        el.setAttribute('aria-current', 'page');
				if(el.closest('.l-nav__children')) {
					const closest = el.closest('.l-nav__item');
					const a = closest.querySelector(':scope > a');
					a.setAttribute('aria-current', 'page');
				}
      }
    }
  });
  [].forEach.call(pageLink, el => {
		if (path.match(el.getAttribute('href'))) {
      if (!el.classList.contains('js-throwgh')) {
        el.setAttribute('aria-current', 'page');
      }
    }
  });
  [].forEach.call(catLink, el => {
		if (path.match(el.getAttribute('href'))) {
       el.closest('li').remove();
    }

  });

	if (path.match('/product/medical_products/')) {
		const items = document.querySelectorAll('.p-catlink li');
		if(items.length > 1) {
			items[2].remove();
		}
 	}
}
